import { styled } from "@mui/material/styles";

export const VideoContainer = styled("div")(({ theme }) => ({
  position: "relative",
  width: "100%",
  maxWidth: "1350px",
  aspectRatio: "16 / 9",
  borderRadius: "12px",
  backgroundColor: "#231F20",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  overflow: "hidden",
  "&:hover": {
    "& .sim-name-overlay": {
      opacity: 1,
    },
  },
  "&.full": {
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 70px)",
      width: "100vw",
      aspectRatio: "9 / 16",
      borderRadius: 0,
      position: "absolute",
      left: 0,
      top: "70px",
    },
  },
  "&.mini": {
    [theme.breakpoints.down("sm")]: {
      height: "400px",
    },
    "& #call-toolbar": {
      maxWidth: "330px",
    },
    "& .video-inner-container": {
      overflow: "visible",
      height: "100%",
    },
  },
  "& #lk-video": {
    width: "100%",
    height: "100%",
    position: "absolute",
    zIndex: 1,
    [theme.breakpoints.down("md")]: {
      aspectRatio: "9 / 16",
      objectFit: "cover",
    },
  },
  "& #video": {
    width: "182px",
    height: "182px",
    [theme.breakpoints.down("md")]: {
      width: "103px",
      height: "103px",
    },
  },
  "& #avatar-pic": {
    width: "182px",
    height: "165px",
    [theme.breakpoints.down("md")]: {
      width: "103px",
      height: "96px",
    },
  },
  "& #manual-connect-button": {
    background: "transparent",
    border: 0,
    color: "#fff",
    position: "absolute",
    zIndex: 99,
    cursor: "pointer",
    fontSize: "40px",
    left: 0,
    right: 0,
    opacity: ".6",
    "&:hover": {
      opacity: 1,
    },
    "& svg": {
      width: 60,
      height: 60,
    },
  },
  "& .sim-name-overlay": {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    padding: "15px",
    background: "linear-gradient(-180deg,rgba(0, 0, 0, 1) 36%, rgba(255, 255, 255, 0) 100%)",
    zIndex: 9999,
    opacity: 0,
    transition: "all 0.2s ease",
  },
}));
